import React from "react";
import { Sparkles, MessageCircle } from "lucide-react";
import { LANDING } from "@/constants/testIds";

const LANGUAGES = [
  { name: "English", greet: "Welcome" },
  { name: "Hausa", greet: "Sannu" },
  { name: "Yoruba", greet: "Káàbọ̀" },
  { name: "Igbo", greet: "Nnọọ" },
  { name: "Swahili", greet: "Karibu" },
  { name: "Zulu", greet: "Sawubona" },
  { name: "French", greet: "Bienvenue" },
  { name: "Arabic", greet: "أهلا" },
  { name: "Portuguese", greet: "Bem-vindo" },
];

const QUESTIONS = [
  "Which product is selling fastest this week?",
  "How much did the city branch make yesterday?",
  "Which customer balances need a follow-up?",
  "What should I restock before the weekend?",
];

export const Multilingual = () => {
  return (
    <section
      id="assistant"
      data-testid={LANDING.multilingual}
      className="relative overflow-hidden bg-[#0A3B3B] text-white py-24 md:py-32"
    >
      <div className="absolute inset-0 bg-kente opacity-[0.12] pointer-events-none" />
      <div className="absolute -top-32 right-0 h-[500px] w-[500px] rounded-full bg-[#D96C4A]/15 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 left-0 h-[400px] w-[400px] rounded-full bg-[#0E6B6B]/35 blur-3xl pointer-events-none" />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-6">
            <span className="text-xs md:text-sm tracking-[0.2em] uppercase font-bold text-[#FFD8A8]">Multilingual assistant</span>
            <h2 className="mt-4 font-display text-3xl md:text-4xl font-semibold leading-[1.1] tracking-tight">
              Ask your shop. <br />
              <span className="italic text-[#FFD8A8]">In your language.</span>
            </h2>
            <p className="mt-5 text-base md:text-lg text-white/80 max-w-xl leading-relaxed">
              Ask everyday questions in English, Hausa, Yoruba, Igbo, Swahili, Zulu, French, Arabic, or Portuguese. Shopbook answers from the business records you are allowed to see—without making you translate your work into accounting jargon.
            </p>

            <div className="mt-8 flex flex-wrap gap-2">
              {LANGUAGES.map((l) => (
                <div
                  key={l.name}
                  data-testid={`language-${l.name.toLowerCase()}`}
                  className="group rounded-full bg-white/8 hover:bg-white/15 transition-colors px-4 py-2 text-sm border border-white/10 cursor-default"
                >
                  <span className="font-display font-semibold text-[#FFD8A8]">{l.greet}</span>
                  <span className="text-white/60 ml-2">· {l.name}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="rounded-3xl bg-white/5 backdrop-blur-sm border border-white/10 p-6 md:p-8">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-2xl bg-[#FFD8A8]/20 flex items-center justify-center">
                  <Sparkles className="h-5 w-5 text-[#FFD8A8]" />
                </div>
                <div>
                  <div className="font-display text-lg font-semibold">Shopbook Assistant</div>
                  <div className="text-xs text-white/60">Powered by your shop data</div>
                </div>
              </div>

              <div className="mt-6 space-y-3">
                {QUESTIONS.map((q, i) => (
                  <div
                    key={q}
                    className="flex items-start gap-3 rounded-2xl bg-white/5 px-4 py-3 border border-white/8"
                    style={{ animationDelay: `${i * 0.15}s` }}
                  >
                    <MessageCircle className="h-4 w-4 mt-1 text-[#FFD8A8] flex-none" />
                    <p className="text-[15px] text-white/90">{q}</p>
                  </div>
                ))}
              </div>

              <div className="mt-6 rounded-2xl bg-[#0E6B6B] p-5 border border-white/10">
                <div className="text-xs uppercase tracking-widest text-white/60 mb-1">Assistant reply</div>
                <p className="font-display text-lg leading-snug">
                  Your fastest-moving item is <span className="text-[#FFD8A8]">Bottled Water</span>. At the current pace, the available stock may run low before the weekend.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Multilingual;
